//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('MetricsHelper', [
    '$filter',
    '$location',
    function(
            $filter,
            $location,
        ) {
      const TEST_VARIATION = 'testVariation';
      const SOURCE_TYPE = 'sourceType';
      const BYPASS_CACHE = 'bypassCache';

      const getQueryParam = (param) => {
        const queryParams = $location.search();
        return decodeURIComponent(queryParams[param] || '');
      };

      const self = this;
      let revenueFormat = 'USD';

      self.setRevenueFormat = (format) => {
        revenueFormat = format;
      };

      self.formatString = (input) => {
        return { value: input.value };
      };

      self.formatPercent = (input) => {
        return { value: $filter('readablePercent')(input.value, /* includePercentSymbol */ true) };
      };

      self.formatMoney = (input) => {
        return { value: $filter('revenueSymbol')(revenueFormat) + $filter('readableNumber')(input.value) };
      };

      self.formatNumber = (input) => {
        return { value: $filter('readableNumber')(input.value) };
      };

      self.formatSecsDecimal = (input) => {
        let numStr;
        let idx;

        numStr = `${input.value}`;
        idx = numStr.indexOf('.');

        if (idx === 0) {
          numStr = `0${numStr}`;
          idx = 1;
        }

        if (idx !== -1) {
          numStr += '00';  // We can safely add zeroes after the decimal place, turning 2.4 into 2.40 after the chop below.
          numStr = numStr.substring(0, idx + 3);
        }

        return { value: numStr };
      };

            // Returns the seconds as a duration formatted as M:SS.
      self.formatMinsDuration = (input) => {
        const minutes = Math.floor(input.value);
        let seconds = Math.floor(input.value * 60) - (minutes * 60);

        if (seconds < 10) {
          seconds = `0${seconds}`;
        }

        return { value: `${minutes}:${seconds}` };
      };

            // Returns the seconds as an integer, rounded to the nearest second.
      self.formatSecsDuration = (input) => {
        return { value: Math.round(input.value) };
      };

      self.getCommonParams = () => {
        return {
          testVariation: getQueryParam(TEST_VARIATION),
          sourceType: getQueryParam(SOURCE_TYPE),
          bypassCache: getQueryParam(BYPASS_CACHE),
        };
      };
    },
  ]);
})();
